"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _Partner = require("./Partner.styles");

var _ApplicationSettings = _interopRequireDefault(require("../services/ApplicationSettings"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref2 = _react.default.createElement(_Partner.PartnerCopyWrapper, null, _react.default.createElement(_Partner.VerticalLine, null), _react.default.createElement(_Partner.PartnerCopy, null, "Together With"));

var Partner = function Partner(_ref) {
  var _ref$partner = _ref.partner,
      _ref$partner$partnerV = _ref$partner.partnerVanityUrlName,
      partnerVanityUrlName = _ref$partner$partnerV === void 0 ? 'notused' : _ref$partner$partnerV,
      partnerLoanApplicationUrl = _ref$partner.partnerLoanApplicationUrl;

  var cdnUrl = _ApplicationSettings.default.getApplicationSetting('cdnUrl');

  return _react.default.createElement(_Partner.PartnerWrapper, {
    "data-qa": "partner"
  }, _react.default.createElement(_Partner.PartnerInner, null, _react.default.createElement(_Partner.PartnerInfo, null, _react.default.createElement(_Partner.PartnerLogoWrapper, null, _react.default.createElement("a", {
    href: partnerLoanApplicationUrl,
    rel: "noopener noreferrer",
    target: "_blank"
  }, _react.default.createElement(_Partner.PartnerLogo, {
    src: "".concat(cdnUrl, "/partner-header-logos-assets/").concat(partnerVanityUrlName.toLowerCase(), ".png"),
    alt: "".concat(partnerVanityUrlName, " Logo")
  }))), _ref2)));
};

var _default = Partner;
exports.default = _default;
module.exports = exports.default;